const SampleRangeStatus = {
    RequiredMinimumVersion: { iOS: '1.0.0' },
    RangeIsClosed: { isClosed: false },
}

export default SampleRangeStatus
